/**
 * Shows the description field on an employer profile
 * @param {node} children will typically be React components
 * for editing the description field (i.e from EditDash)
 */
import React from 'react';
import PropTypes from 'prop-types';

export default class ProfileDescription extends React.Component {
    static propTypes = {
        header: PropTypes.string,
        text: PropTypes.string,
        inline: PropTypes.string,
        companyName: PropTypes.string,
    };

    render() {
        return (
            <div className={this.props.className}>
                <h2>
                    {this.props.header}
                    {this.props.children}
                </h2>

                {this.props.text ? (
                    <p className="u-t3">{this.props.text}</p>
                ) : null}
                <p className="u-stone">{this.props.inline}</p>
            </div>
        );
    }
}
